import React, { useState, useEffect } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Sidebar from './Sidebar';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PageProps } from '../types';
import Navigation from '../pages/strategic_performance/components/Navigation';
import '../pages/strategic_performance/index.css';

interface StrategicPerformanceLayoutProps {
  children: React.ReactNode;
  pages: PageProps[];
}

const StrategicPerformanceLayout: React.FC<StrategicPerformanceLayoutProps> = ({ children, pages }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);
  const [activePageTitle, setActivePageTitle] = useState('Strategic Performance');
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  const handlePageChange = (title: string) => {
    setActivePageTitle(title);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const pagePropsList: PageProps[] = pages.map((page) => ({
    title: page.title,
    icon: page.icon || null,
    tabs: page.tabs,
    path: page.path,
    show: page.show,
    element: page.element
  }));

  return (
    <div className="strategic-performance-module">
      <Box sx={{
        display: 'flex',
        height: '100vh',
        overflow: 'hidden',
        bgcolor: '#F9FAFB'
      }}>
        <Sidebar
          isOpen={isSidebarOpen}
          onToggle={toggleSidebar}
          activePageTitle={activePageTitle}
          onPageChange={handlePageChange}
          pagePropsList={pagePropsList}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: isSidebarOpen ? '310px' : '64px',
            height: '100vh',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            '@media (max-width: 600px)': {
              marginLeft: isSidebarOpen ? '0' : '64px',
              width: '100%',
            },
          }}
        >
          <Navigation />
          <Box sx={{ flex: 1, overflow: 'auto' }}>
            {children}
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default StrategicPerformanceLayout;
